import apiService from './ApiService';

class RankingService {
  getComparison({ userIds, granularity = 'WEEKLY', periods = 12 } = {}) {
    const params = new URLSearchParams({ userIds: (userIds || []).join(','), granularity, periods });
    return apiService.get(`/api/v1/game/rankings/comparison?${params.toString()}`);
  }
}

export default new RankingService();
